import { render, staticRenderFns } from "./addRoleDialog.vue?vue&type=template&id=a4e2a196&scoped=true"
import script from "./addRoleDialog.vue?vue&type=script&lang=js"
export * from "./addRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./addRoleDialog.vue?vue&type=style&index=0&id=a4e2a196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e2a196",
  null
  
)

export default component.exports